import "./ContactUs.module.css";
import Navigation from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Location from "./sections/Location";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Navigation />
      <Contact />
      <Location />
      <Footer />
    </div>;
}